import React from "react";

export const BasePath = `/Portfolio`;
export const HomePath = ``;

export const FinalizedTime = true;

export enum Paths {
  Home = "",
  Attire = "attire",
  Entourage = "entourage",
  Schedule = "schedule",
  Travel = "travel",
  Gallery = "gallery",
  Faq = "faq",
  Rsvp = "rsvp",
  Mochi = "mochi",
  Story = "our-story",
  ToDo = "things-to-do",
  Login = "admin/login",
  Dashboard = "admin/dashboard",
  Guest = "admin/guest",
}

const WebsiteTitle = "Warren & Krizia's Wedding";

export enum PathName {
  Home = `${WebsiteTitle} | 03.03.26 | El Jardin de Zaida`,
  Attire = `${WebsiteTitle} | Attire`,
  Entourage = `${WebsiteTitle} | Entourage`,
  Schedule = `${WebsiteTitle} | Schedule`,
  Travel = `${WebsiteTitle} | Travel`,
  Gallery = `${WebsiteTitle} | Gallery`,
  Faq = `${WebsiteTitle} | FAQ`,
  Rsvp = `${WebsiteTitle} | RSVP`,
  Mochi = `${WebsiteTitle} | Mochi`,
  Story = `${WebsiteTitle} | Our Story`,
  ToDo = `${WebsiteTitle} | Things To Do`,
  Login = `${WebsiteTitle} | Login`,
  Dashboard = `${WebsiteTitle} | Dashboard`,
}

export const PageSeoData = {
  [Paths.Home]: {
    title: PathName.Home,
    description:
      "Join Warren Atchison and Krizia Uayan as they say 'I do' on March 03, 2026 at El Jardin de Zaida. All the wedding details, travel tips, and RSVP info in one lovely place.",
  },
  [Paths.Attire]: {
    title: PathName.Attire,
    description:
      "Discover the recommended wedding attire for Warren and Krizia's celebration, including color themes, and style suggestions for an outdoor garden setting.",
  },
  [Paths.Entourage]: {
    title: PathName.Entourage,
    description:
      "Meet the cherished family and friends who will be standing beside Warren and Krizia on their special day, each playing a meaningful role in their journey to 'I do.'",
  },
  [Paths.Schedule]: {
    title: PathName.Schedule,
    description:
      "View the schedule of events for Warren and Krizia's wedding day, from the ceremony to the reception, and join in every memorable moment at El Jardin de Zaida.",
  },
  [Paths.Travel]: {
    title: PathName.Travel,
    description:
      "Find all the essential travel information for Warren and Krizia's wedding, including accommodation, transportation, and local tips to help you plan your journey.",
  },
  [Paths.Gallery]: {
    title: PathName.Gallery,
    description:
      "Take a glimpse into Warren and Krizia's love story through a collection of heartfelt moments and pre-wedding photos captured along the way.",
  },
  [Paths.Faq]: {
    title: PathName.Faq,
    description:
      "Find answers to common questions about Warren and Krizia's wedding, including venue details, dress code, travel arrangements, and RSVP information.",
  },
  [Paths.Rsvp]: {
    title: PathName.Rsvp,
    description:
      "RSVP for Warren and Krizia's wedding! Confirm your attendance and select your preferences for the special day at El Jardin de Zaida.",
  },
  [Paths.Story]: {
    title: PathName.Story,
    description:
      "Discover the journey of Warren and Krizia, a story of shared passions, long distance love, and a beautiful path to forever, leading to their wedding celebration.",
  },
  [Paths.ToDo]: {
    title: PathName.ToDo,
    description: "",
  },
};

export const PageList = [
  { label: "Home", value: Paths.Home },
  { label: "Schedule", value: Paths.Schedule },
  { label: "Travel", value: Paths.Travel },
  { label: "", value: Paths.Home, isLogo: true },
  { label: "Attire", value: Paths.Attire },
  { label: "Entourage", value: Paths.Entourage },
  { label: "RSVP", value: Paths.Rsvp },
];

export const FooterPageList = [
  { label: "Home", value: Paths.Home },
  { label: "Our Story", value: Paths.Story },
  { label: "Schedule", value: Paths.Schedule },
  { label: "Travel", value: Paths.Travel },
  { label: "Attire", value: Paths.Attire },
  { label: "Entourage", value: Paths.Entourage },
  { label: "Gallery", value: Paths.Gallery },
  { label: "Things To Do", value: Paths.ToDo },
  { label: "FAQ", value: Paths.Faq },
  { label: "RSVP", value: Paths.Rsvp },
  // { label: "Mochi", value: Paths.Mochi },
];

export const GrabPlayStore =
  "https://play.google.com/store/apps/details?id=com.grabtaxi.passenger&pcampaignid=web_share";

export const GrabAppStore =
  "https://apps.apple.com/sg/app/grab-taxi-ride-food-delivery/id647268330";

export const EGovPHPlayStore =
  "https://play.google.com/store/apps/details?id=egov.app&pcampaignid=web_share";

export const EGovPHAppStore =
  "https://apps.apple.com/ph/app/egovph/id6447682225";

export const ElJardinDeZaidaSite = "https://www.eljardindezaida.com.ph/";
export const CrescentNorthMaps = "https://maps.app.goo.gl/UF6WKSK2c49hFyMg7";

export const AirBnB =
  "https://www.airbnb.com/s/Bonifacio-Global-City--Metro-Manila/homes?flexible_trip_lengths%5B%5D=one_week&monthly_start_date=2025-05-01&monthly_length=3&monthly_end_date=2025-08-01&place_id=ChIJr5Qp-vPIlzMRCuRgR6-IyYk&refinement_paths%5B%5D=%2Fhomes&acp_id=26d3dbcf-ad18-4abd-87b9-621b9c8b96b0&date_picker_type=flexible_dates&flexible_trip_dates%5B%5D=march&adults=2&source=structured_search_input_header&search_type=user_map_move&query=Bonifacio%20Global%20City%2C%20Metro%20Manila&search_mode=regular_search&price_filter_input_type=2&price_filter_num_nights=5&channel=EXPLORE&ne_lat=14.559992301972828&ne_lng=121.05463374185615&sw_lat=14.54486475565919&sw_lng=121.04370333353063&zoom=15.83356286940874&zoom_level=15.83356286940874&search_by_map=true";

export const GoogleMapsHotel =
  "https://www.google.com/travel/search?q=BGC&qs=CAEgACgAOA1IAA&ved=0CAAQ5JsGahgKEwigr8615_eMAxUAAAAAHQAAAAAQlAE&ts=CAESCgoCCAMKAggDEAAaPQofEhsKCS9tLzA3d2cwMDoORm9ydCBCb25pZmFjaW8aABIaEhQKBwjqDxADGAESBwjqDxADGAcYBjICCAEqCQoFOgNQSFAaAA&ap=KigKEgl1RIBVqBMtQBEEd5zSdkJeQBISCcqPcPKQIi1AEQR3nKbOQ15AMAE";

export interface InvitesData {
  inviteId: string;
  displayName: string;
  email: string;
  willAttend: boolean;
  responded: boolean;
  maxGuests: number;
  attendingGuests: number;
  action: React.ReactElement;
}

export interface InvitesHeadCell {
  id: keyof InvitesData;
  label: string;
}

export const InvitesHeadCells: readonly InvitesHeadCell[] = [
  {
    id: "inviteId",
    label: "Invite Code",
  },
  {
    id: "displayName",
    label: "Display Name",
  },
  {
    id: "email",
    label: "Email",
  },
  {
    id: "responded",
    label: "Responded",
  },
  {
    id: "willAttend",
    label: "Attending",
  },
  {
    id: "maxGuests",
    label: "Allowed Guests",
  },
  {
    id: "attendingGuests",
    label: "Guests",
  },
  {
    id: "action",
    label: "Action",
  },
];

export function createInvitesData(
  inviteId: string,
  displayName: string,
  email: string,
  responded: boolean,
  willAttend: boolean,
  maxGuests: number,
  attendingGuests: number,
  action: React.ReactElement
): InvitesData {
  return {
    inviteId,
    displayName,
    email,
    responded,
    willAttend,
    maxGuests,
    attendingGuests,
    action,
  };
}

export const EmptyDetails = { firstName: "", lastName: "", diet: "" };
export const RadioOptions = [
  { label: "Gladly!", value: "accept" },
  { label: "Regretfully, I can't make it.", value: "decline" },
];
export const RespondOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];
